<template>
  <div>
    <b-card
      v-if="dataItem.lines.length"
      no-body
    >
      <b-table
        responsive="sm"
        :fields="fields"
        :items="dataItem.lines"
        striped
      >
        <template #cell(notes)="data">
          <div
            class="font-small-2 text-warning"
          >
            {{ moment(data.item.ddate).format('ll') }}
          </div>
          <div>
            {{ data.item.notes }}
          </div>
          <div class="text-muted font-small-2">
            {{ moment(data.item.created).format('llll') }} tarihinde {{ data.item.username }} tarafından oluşturuldu.
          </div>
          <div
            v-if="data.item.modified"
            class="text-muted font-small-2"
          >
            {{ moment(data.item.modified).format('llll') }} tarihinde {{ data.item.username }} tarafından oluşturuldu.
          </div>
        </template>
        <template #cell(amount)="data">
          <div v-if="data.item.amount">
            {{ data.item.amount | toCurrency }} TL
          </div>
        </template>
        <template #cell(control)="data">
          <div class="text-right">
            <list-buttons
              primary-text="Görüntüle"
              edit-text="Güncelle"
              :primary-action="$route.path + '/view/' + data.item.id"
              :edit-action="$route.path + '/edit/' + data.item.id"
              :delete-action="removeData"
              :data-id="data.item.id"
            />
          </div>
        </template>
      </b-table>
    </b-card>
  </div>
</template>
<script>
import {
  BCard, BTable,
} from 'bootstrap-vue'
import ListButtons from '@/layouts/components/common/ListDropdownButtons.vue'
import moment from 'moment'

export default {
  name: 'LinesCard',
  components: {
    ListButtons,
    BCard,
    BTable,
  },
  data() {
    return {
      fields: [
        {
          key: 'notes',
          label: 'AÇIKLAMA',
        },
        {
          key: 'amount',
          label: 'TUTAR',
          thClass: 'width-100 text-nowrap',
          tdClass: 'width-100 text-nowrap',
        },
      ],
    }
  },
  computed: {
    moment() {
      return moment
    },
    dataItem() {
      return this.$store.getters['promissories/dataItem']
    },
  },
  methods: {
    removeData(id) {
      this.$swal({
        title: this.$store.state.app.removeTitle,
        text: this.$store.state.app.removeMessage,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$store.state.app.removeConfirm,
        cancelButtonText: this.$store.state.app.removeCancel,
        customClass: {
          confirmButton: 'btn btn-success',
          cancelButton: 'btn btn-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          this.$store.dispatch('promissoryLines/removeData', id)
          this.$swal({
            icon: 'success',
            title: this.$store.state.app.removeResultTitle,
            text: this.$store.state.app.removeResultMessage,
            confirmButtonText: this.$store.state.app.removeResultClose,
            customClass: {
              confirmButton: 'btn btn-success',
            },
          })
        }
      })
    },
  },
}
</script>
